export default function Select() {
  return {
    controlHeightSM: 40,
    controlHeight: 47,
    controlHeightLG: 54
  }
}
